import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import API_CONFIG from './config/api';
import Dashboard from './Dashboard';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  // Verificar token salvo na inicialização
  useEffect(() => {
    const checkSavedToken = async () => {
      const savedToken = localStorage.getItem('token');
      const savedUser = localStorage.getItem('user');
      
      if (savedToken && savedUser) {
        try {
          // Verificar se o token ainda é válido
          const response = await axios.post(`${API_CONFIG.API_URL}/auth/verify`, {}, {
            headers: {
              'Authorization': `Bearer ${savedToken}`
            }
          });
          
          if (response.data.success) {
            setIsLoggedIn(true);
            setUser(JSON.parse(savedUser));
            setMessage('Login restaurado com sucesso!');
            
            // Limpar contexto de loja se não for super_admin
            const userData = JSON.parse(savedUser);
            if (userData.tipo !== 'super_admin') {
              localStorage.removeItem('lojaContexto');
            }
          } else {
            // Token inválido, remover dados salvos
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('lojaContexto');
          }
        } catch (error) {
          // Token inválido ou erro de conexão, remover dados salvos
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('lojaContexto');
        }
      }
      setChecking(false);
    };

    checkSavedToken();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await axios.post(`${API_CONFIG.API_URL}/auth/web-login`, {
        username: formData.username,
        password: formData.password
      });

      if (response.data.success) {
        setMessage('Login realizado com sucesso!');
        setIsLoggedIn(true);
        setUser(response.data.user);
        
        // Armazenar token e dados do usuário
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        // Limpar contexto de loja se não for super_admin
        if (response.data.user.tipo !== 'super_admin') {
          localStorage.removeItem('lojaContexto');
        }
        
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setMessage(error.response.data.message);
      } else {
        setMessage('Erro ao conectar com o servidor');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    setFormData({ username: '', password: '' });
    setMessage('');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('lojaContexto');
  };

  // Efeito para redirecionar Super Admin
  useEffect(() => {
    const lojaContexto = localStorage.getItem('lojaContexto');
    if (isLoggedIn && user && (user.tipo === 'super_admin' || user.cargo === 'Admin') && !lojaContexto) {
      navigate('/admin/lojas');
    }
  }, [isLoggedIn, user, navigate]);

  // Tela de loading durante verificação do token
  if (checking) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2>Verificando login...</h2>
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <div style={{ 
              border: '3px solid #f3f3f3',
              borderTop: '3px solid #667eea',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              animation: 'spin 1s linear infinite',
              margin: '0 auto'
            }}></div>
          </div>
        </div>
      </div>
    );
  }

  if (isLoggedIn && user) {
    const lojaContexto = localStorage.getItem('lojaContexto');
    if ((user.tipo === 'super_admin' || user.cargo === 'Admin') && !lojaContexto) {
       return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f7fafc', color: '#4a5568' }}>Redirecionando para o painel administrativo...</div>
    }
    return (
      <Dashboard user={user} onLogout={handleLogout} />
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img src="/logo.png" alt="VETIM" />
          </div>
          <p className="subtitle">A evolução dos financiamentos</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Usuário</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Digite seu usuário"
              autoComplete="username"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Digite sua senha"
              autoComplete="current-password"
            />
          </div>

          {message && (
            <div className={`message ${message.includes('sucesso') ? 'success' : 'error'}`}>
              {message}
            </div>
          )}

          <button type="submit" disabled={loading} className="login-btn">
            {loading ? (
              <>
                <span className="spinner"></span>
                Entrando...
              </>
            ) : (
              'Entrar'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;